/**
 * Lord of Riches 源站 `install_1`：已安装则跳过，iOS 走加主屏幕条，其它走 beforeinstallprompt。
 */

type BeforeInstallPromptEvent = Event & {
  prompt: () => Promise<void>;
  userChoice: Promise<{ outcome: 'accepted' | 'dismissed' }>;
};

export type LorUsAppInstallResult = 'ios' | 'prompted' | 'standalone' | 'unavailable';

let deferred: BeforeInstallPromptEvent | null = null;
let listening = false;

export function listenLorUsAppInstall(): void {
  if (listening || typeof window === 'undefined') return;
  listening = true;
  window.addEventListener('beforeinstallprompt', (event) => {
    event.preventDefault();
    deferred = event as BeforeInstallPromptEvent;
  });
}

export function isLorUsStandalone(win: Window = window): boolean {
  return (
    win.matchMedia('(display-mode: standalone)').matches ||
    Boolean((win.navigator as Navigator & { standalone?: boolean }).standalone)
  );
}

export function isLorUsIos(nav: Pick<Navigator, 'platform' | 'userAgent'> & { maxTouchPoints?: number } = navigator): boolean {
  return (
    /iPad|iPhone|iPod/.test(nav.userAgent) ||
    (nav.platform === 'MacIntel' && (nav.maxTouchPoints ?? 0) > 1)
  );
}

export async function promptLorUsAppInstall(): Promise<LorUsAppInstallResult> {
  if (typeof window === 'undefined') return 'unavailable';
  if (isLorUsStandalone()) return 'standalone';
  if (deferred) {
    await deferred.prompt();
    deferred = null;
    return 'prompted';
  }
  if (isLorUsIos()) return 'ios';
  return 'unavailable';
}

/** 仅测试：注入 / 清空 deferred prompt。 */
export function setLorUsDeferredPromptForTest(event: BeforeInstallPromptEvent | null): void {
  deferred = event;
}
